// extracted by mini-css-extract-plugin
export var features = "PlusCheckout-module__features___hYkVR";
export var li = "PlusCheckout-module__li___wm_b6";
export var more = "PlusCheckout-module__more___v77lH";
export var s = "PlusCheckout-module__s___MUSqV";
export var ul = "PlusCheckout-module__ul___Ejj_d";